import { Component, OnDestroy, OnInit } from '@angular/core';
import {ApiService} from '../../services/api.service';
import {Automobilia} from '../../models/automobilia.model';
import { SearchService } from '../../services/search.service';

@Component({
  selector: 'app-automobilia',
  templateUrl: './automobilia.component.html'
})
export class AutomobiliaComponent implements OnInit, OnDestroy {

  title = [
    '_AUTOMOBILIA.TITLE_1',
    '_AUTOMOBILIA.TITLE_2'
  ];

  automobilia: Array<Automobilia> = [];
  automobiliaBackup: Array<Automobilia> = [];

  automobiliaPerPage = 25;
  currentPage = 1;
  scrollToggle: boolean;

  constructor(private api: ApiService,
              private searchService: SearchService) {
    this.searchService.doSearch.subscribe(searchTerm => {
      if (searchTerm) {
        this.updateSearch(searchTerm);
      } else {
        this.automobilia = this.automobiliaBackup;
      }
    });
  }

  ngOnInit() {
    this.searchService.active = true;
    this.searchService.searchTerm = '';
    this.searchService.reset();

    this.api.getAutomobiliaForSale().subscribe((automobiliaForSale: Automobilia[]) => {

      automobiliaForSale.sort((a, b) => {
        if (a.title < b.title) { return -1; }
        if (a.title > b.title) { return 1; }
        return 0;
      });

      this.automobilia = automobiliaForSale;
      this.automobiliaBackup = automobiliaForSale;
    });
  }

  ngOnDestroy(): void {
    this.searchService.active = false;
  }

  pageChange(event) {
    this.currentPage = event;
    this.scrollToggle = !this.scrollToggle;
  }

  updateSearch(searchTerm: string) {
    this.pageChange(1);
    this.automobilia = this.automobiliaBackup.filter((automobilia: Automobilia, index) => {
      return (automobilia.title.toLowerCase().search(searchTerm.toLowerCase()) !== -1)
        || (automobilia.description.toLowerCase().search(searchTerm.toLowerCase()) !== -1);
    });
  }
}
